export default __webpack_public_path__ + "assets/fonts/a394993d0f4d28d3442596a2702f5d5f.woff";